import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/Rec_alpha_black_portrait.png';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="REC 365W ALPHA Premium Panel" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/REC365ALPHA.js